import { useState } from 'react';
import { useOnWindowResize } from '@common/Hooks/useOnWindowResize';
import { DROPDOWN_CONTAINER_IDENTIFIER, DROPDOWN_SECTION_IDENTIFIER } from '../containers/PageHeaderConstants';

const MIN_BANNER_SPACE = 450;

export const useSpaceForBannerAvailable = () => {
    const [isEnoughSpace, setIsEnoughSpace] = useState(true);

    const calculateSpace = () => {
        const dropdownContainer = document.querySelector(`.${DROPDOWN_CONTAINER_IDENTIFIER}`);
        const dropdownsColumns = document.querySelectorAll(`.${DROPDOWN_SECTION_IDENTIFIER}`);

        if (!dropdownContainer || !dropdownsColumns?.length) {
            return false;
        }

        const visibleDropdownsColumns = Array.from(dropdownsColumns).filter((element) => {
            const { visibility } = window.getComputedStyle(element, null);
            return visibility !== 'hidden';
        });

        const { paddingLeft, paddingRight } = window.getComputedStyle(dropdownContainer, null);
        const containerHorizontalPadding = parseFloat(paddingLeft) + parseFloat(paddingRight);

        const dropdownContainerWidth = dropdownContainer.clientWidth - containerHorizontalPadding;

        const accWidth = Array.from(visibleDropdownsColumns).reduce((total, currentElement) => {
            const { marginRight } = window.getComputedStyle(currentElement, null);
            const elementTotalWidth = currentElement.clientWidth + parseFloat(marginRight);
            return total + elementTotalWidth;
        }, 0);

        const remainingSpace = dropdownContainerWidth - accWidth;

        setIsEnoughSpace(remainingSpace >= MIN_BANNER_SPACE);

        return false;
    };

    useOnWindowResize(calculateSpace);

    return isEnoughSpace;
};
